/* eslint-disable import/prefer-default-export */
export const canUserSeeFullPhone = (user) => !user || user.can_view_phone_numbers;
